import {
  AfterContentInit,
  Component,
  Directive,
  ElementRef,
  Renderer2,
  ViewChild,
} from '@angular/core';

@Directive({
  selector: '[appToolbarItemBefore]',
})
export class ToolbarItemBeforeDirective {}

@Directive({
  selector: '[appToolbarItemCenter]',
})
export class ToolbarItemCenterDirective {}

@Directive({
  selector: '[appToolbarItemAfter]',
})
export class ToolbarItemAfterDirective {}

@Component({
  selector: 'app-toolbar',
  templateUrl: 'toolbar.component.html',
  styleUrls: ['toolbar.component.scss'],
})
export class ToolbarComponent implements AfterContentInit {
  @ViewChild('beforeContainerRef', { static: true })
  beforeContainerRef: ElementRef<HTMLDivElement>;
  @ViewChild('centerContainerRef', { static: true })
  centerContainerRef: ElementRef<HTMLDivElement>;
  @ViewChild('afterContainerRef', { static: true })
  afterContainerRef: ElementRef<HTMLDivElement>;

  // @ContentChildren(ToolbarItemDirective, { descendants: true })
  // toolItems: QueryList<ToolbarItemDirective>;

  constructor(private renderer: Renderer2) {}

  ngAfterContentInit(): void {
    // this.toolItems.changes.subscribe((e) => {
    //   console.log(e);
    //   // this.syncToolItems();
    // });
    // this.syncToolItems();
  }

  private syncToolItems() {
    // const itemsBefore = this.toolItems.filter((x) => x.location === 'before');
    // const itemsCenter = this.toolItems.filter((x) => x.location === 'center');
    // const itemsAfter = this.toolItems.filter((x) => x.location === 'after');
    // this.beforeContainerRef.nativeElement.innerHTML = '';
    // this.centerContainerRef.nativeElement.innerHTML = '';
    // this.afterContainerRef.nativeElement.innerHTML = '';
    // for (const item of itemsBefore) {
    //   this.renderer.appendChild(
    //     this.beforeContainerRef.nativeElement,
    //     item.elementRef.nativeElement
    //   );
    // }
    // for (const item of itemsCenter) {
    //   this.renderer.appendChild(
    //     this.centerContainerRef.nativeElement,
    //     item.elementRef.nativeElement
    //   );
    // }
    // for (const item of itemsAfter) {
    //   this.renderer.appendChild(
    //     this.afterContainerRef.nativeElement,
    //     item.elementRef.nativeElement
    //   );
    // }
  }
}
